import { RefObject, useEffect, useState } from 'react';

/**
 * Detects horizontal text overflow (ellipsis). Uses ResizeObserver and
 * deferred rAF checks so table / flex layouts are measured after final layout.
 */
export const useOverflowDetection = (
  ref: RefObject<HTMLElement>,
  contentKey?: string | number,
) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let cancelled = false;

    const update = () => {
      if (cancelled || !el.isConnected) return;
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    };

    update();

    requestAnimationFrame(() => {
      if (!cancelled) update();
      requestAnimationFrame(() => {
        if (!cancelled) update();
      });
    });

    const observer = new ResizeObserver(update);
    observer.observe(el);

    return () => {
      cancelled = true;
      observer.disconnect();
    };
  }, [ref, contentKey]);

  return isOverflowing;
};
